<template>
  <span class="cam">Code & Magic</span>
</template>

<style scoped>
.cam {
    /* font-family: "Kaisei Decol", serif !important; */
    /* font-weight: 500 !important; */
    /* font-family: "Noto Serif JP", serif !important; */
    font-family: "Source Serif", serif !important;
    font-weight: 600 !important;
}
</style>
